import VueRouter from  'vue-router'
import store from '../store'
import ToolList from '../components/toollist.vue'
import tts from '../components/tts'
import Azuretts from '../components/Azuretts.vue'
import DigitalHumanAvatar from '../components/DigitalHumanAvatar.vue'
import AvatarVideoGenerator from '../components/AvatarVideoGenerator.vue'
import Speech2text from '../components/Speech2text.vue'
import TitleTool from '../components/TitleTool.vue'
import ImageGenerator from '../components/ImageGenerator.vue'
import AiImageGenerator from '../components/AiImageGenerator.vue'
import PptSlides from '../components/PptSlides.vue'
import KeyboardTest from '../components/KeyboardTest.vue'
import FlipMemoryGame from '../components/FlipMemoryGame.vue'
import ImageTextCutout from '../components/ImageTextCutout.vue'
import VideoDownloader from '../components/VideoDownloader.vue'
import WeChatVideoBot from '../components/WeChatVideoBot.vue'
import SolutionCatalog from '../components/SolutionCatalog.vue'
import PixabaySearch from '../components/PixabaySearch.vue'
import ScoreScreenBridge from '../components/ScoreScreenBridge.vue'
import music from '@/components/music.vue'
import UserProfile from '../components/UserProfile.vue'

const router = new VueRouter({
    routes: [
        {
            path: '/',
            component: ToolList
        },
        {
            path: '/user',
            component: UserProfile,
            meta: { requireAuth: true }
        },
        {
            path:'/Azuretts',
            component:Azuretts
        },
        {
            path:'/Speech2text',
            component:Speech2text
        },
        {
            path:'/digital-human',
            component:DigitalHumanAvatar
        },
        {
            path:'/digital-human-video',
            component:AvatarVideoGenerator
        },
        {
            path:'/tts',
            component:tts
        },
        {
            path:'/title',
            component:TitleTool
        },
        {
            path:'/image-generator',
            component:ImageGenerator
        },
        {
            path:'/ai-image-generator',
            component:AiImageGenerator
        },
        {
            path:'/pixabay-search',
            component:PixabaySearch
        },
        {
            path:'/ppt-slides',
            component:PptSlides
        },
        {
            path:'/ppt-slides/edit/:name',
            component:PptSlides,
            name:'PptSlidesEdit'
        },
        {
            path:'/keyboard-test',
            component:KeyboardTest
        },
        {
            path: '/flip-memory',
            component: FlipMemoryGame
        },
        {
            path:'/music',
            component:music
        },
        {
            path:'/text-cutout',
            component: ImageTextCutout
        },
        {
            path:'/video-downloader',
            component: VideoDownloader
        },
        {
            path:'/wechat-video-bot',
            component: WeChatVideoBot
        },
        {
            path:'/score-screen-helper',
            component: ScoreScreenBridge
        },
        {
            path:'/solutions',
            component: SolutionCatalog
        },
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth && !store.state.user) {
        store.commit('SetShowLoginDialog', { show: true, tab: 'login' })
        next(false)
    } else {
        next()
    }
})

export default router
